import React, { useEffect } from "react";
import { useStateManagerContext } from "~/context/stateManager";
import { ChannelEvents } from "@local-logic/channel";

/**
 * SDKs wrapped in ResizeWrapper will automatically adjust their height to fit
 * the content.
 *
 * To read more about this functionality see:
 * https://locallogic.atlassian.net/wiki/spaces/PROD/pages/2050031624/Adjustable+vs+nonadjustable+SDK+sizing
 */
const ResizeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { followerNode } = useStateManagerContext();

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      followerNode?.message(ChannelEvents.RESIZE, {
        scrollHeight: document.body.scrollHeight,
        scrollWidth: document.body.scrollWidth,
      });
    });

    observer.observe(document.body);

    return () => observer.unobserve(document.body);
  }, []);

  return <>{children}</>;
};

export default ResizeWrapper;
